// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4ff0ef2e","453":"9420fb6d","455":"6b1fd517","977":"903d11b4"}[chunkId] + ".chunk.js";
};